import Button from '../Button'

import '../../styles/components/RequestCard.css'

const RequestCard = (props) => {
    let classes = ['request-card', props.className].join(' ')

    return (
        <div className={classes}>
            <div className='flex flex-col relative z-10'>
                <div className='flex justify-between items-center mb-4 font-semibold'>
                    <div className='flex items-center'>
                        <svg className='mr-1.5' width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="2.73682" y="2.85718" width="1.36849" height="7.14286" rx="0.684246" fill="black"/>
                            <rect x="6.84277" y="2.85718" width="1.42857" height="6.84246" rx="0.714286" transform="rotate(90 6.84277 2.85718)" fill="black"/>
                            <rect x="6.84277" width="1.42857" height="6.84246" rx="0.714286" transform="rotate(90 6.84277 0)" fill="black"/>
                        </svg>
                        <span>
                            {props.price.from} - {props.price.to} 
                        </span>
                    </div>
                    <div className='flex items-center'>
                        <div className='flex items-center mr-2'>
                            <img src="/icons/user.svg" className='mr-1.5' alt="icon" width='15' height='13' />
                            {props.peopleCount}
                        </div>
                        <div className='flex items-center'>
                            <img src="/icons/box.svg" className='mr-1.5' alt="icon" width='13' height='13' />
                            {props.roomsCount}
                        </div>
                    </div>
                </div>
                <div className='flex items-center mb-2'>
                    <img src="/icons/place.svg" className='mr-1.5' alt="icon" width='13' height='13' />
                    {props.location}
                </div>
                <div className='flex items-center justify-between'>
                    <div className='flex items-center mr-2'>
                        <img src="/icons/calendar.svg" className='mr-1.5' alt="icon" width='13' height='13' />
                        {props.rentTime.from} - {props.rentTime.to} 
                    </div>
                    <div className='flex items-center'>
                        <img src="/icons/time.svg" className='mr-1.5' alt="icon" width='13' height='13' />
                        {props.checkInTime.from} - {props.checkInTime.to} 
                    </div>
                </div>
            </div>
            <div className='request-card__info absolute z-2 top-[100%] left-0 rounded-b-[30px] w-full bg-white opacity-0 transition-all duration-500'>
                <div className='flex items-center mb-4'>
                    <img src={props.landlord.img} className='rounded-full mr-1.5' alt={props.landlord.name} width='32' height='32' />
                    <div className='flex flex-col'>
                        <div className='font-semibold'>{props.landlord.name}</div>
                        <div className='flex items-center'>
                            <img src="/icons/star.svg" alt="rating" width='13' height='13' className='mr-1' />
                            {props.landlord.rating}
                        </div>
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-x-4 gap-y-2 mb-4'>
                    {
                        props.included.map((el) => {
                            return (
                                <div className='flex items-center'>
                                    <img src="/icons/users-black.svg" alt="icon" width='15' height='13' className='mr-1' />
                                    {el}
                                </div>
                            )
                        })
                    }
                </div>
                <div className='flex items-center'> 
                    <img src="/icons/message.svg" alt="icon" width='13' height='13' className='mr-1.5' />
                    Комментарий
                    <div className='flex-grow h-px bg-gray-400 ml-2'></div>
                </div>
                <textarea className='request-textarea' placeholder='Добрый день) Подскажите, могу ли я заселиться в 20:00?'></textarea>
                <Button className='btn-purple'>Ответить на заявку</Button>
            </div>
        </div>
    )
}

export default RequestCard;